module.exports = __webpack_public_path__ + "img/50.f37cacb5.jpg";